import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import QRCode from "react-qr-code";

export function SimulateQR() {
    const [raveId, setRaveId] = useState("");
    const [ticketType, setTicketType] = useState("");
    const [ticketId, setTicketId] = useState("");
    return (
        <div>
            <h2>Simulate QR Code</h2>

            <p>Enter the details for the QR code:</p>
            <label>
                Rave ID:
                <input
                    onChange={(e) => setRaveId(e.target.value)}
                    type="text"
                    id="raveId"
                    placeholder="Enter Rave ID"
                    style={{ color: "black" }}
                />
            </label>
            <label>
                Ticket Type:
                <input
                    onChange={(e) => setTicketType(e.target.value)}
                    type="text"
                    id="ticketType"
                    placeholder="Enter Ticket Type"
                    style={{ color: "black" }}
                />
            </label>
            <label>
                Ticket ID:
                <input
                    onChange={(e) => setTicketId(e.target.value)}
                    type="text"
                    id="ticketId"
                    placeholder="Enter Ticket ID"
                    style={{ color: "black" }}
                />
            </label>

            <div className="qr-code-container" style={{ marginTop: "20px", padding: "40px", backgroundColor: "#282828ff" }}>
                <QRCode value={`${raveId}/${ticketType}/${ticketId}`} />
            </div>
        </div>
    );
}

export default function TestsMenu() {
    return (
        <div>
            <h1>Tests Menu</h1>
            <Routes>
                <Route path="qr" element={<SimulateQR />} />
            </Routes>
        </div>
    );
}